import React from 'react'
import Icon from '../../svg/Icon'

export const Translator = () => {
  return (
    <div className="content">
      <div className="light-tile">
        <h2>Automatic translation</h2>
        <p>
          Use automatic translation to access any page of our website in your
          preferred language.
        </p>
        <div className="form-field as-row">
          <label htmlFor="language" className="sr-only">
            Select a language to translate this page into
          </label>
          <select id="language">
            <option value="en">English</option>
            <option value="ar">عربي</option>
            <option value="bn">Bengali</option>
            <option value="bs-Latn">Bosnian</option>
            <option value="bg">Bulgarian</option>
            <option value="zh-CHS">中文</option>
            <option value="hr">Croatian</option>
            <option value="cs">Czech</option>
            <option value="da">Danish</option>
            <option value="et">Estonian</option>
            <option value="nl">Nederlands</option>
            <option value="fi">Finnish</option>
            <option value="fr">Français</option>
            <option value="de">Deutsch</option>
            <option value="el">Ελληνικά</option>
            <option value="he">Hebrew</option>
            <option value="hi">हिन्दी</option>
            <option value="hu">Hungarian</option>
            <option value="id">Bahasa Indonesia</option>
            <option value="it">Italian</option>
            <option value="ja">日本語</option>
            <option value="ko">한국어</option>
            <option value="lv">Latvian</option>
            <option value="lt">Lithuanian</option>
            <option value="pl">Polish</option>
            <option value="pt">Português</option>
            <option value="ro">Romanian</option>
            <option value="ru">Pусский</option>
            <option value="sr-Latn">Cрпски</option>
            <option value="sk">Slovak</option>
            <option value="sl">Slovene</option>
            <option value="es">Español</option>
            <option value="sv">Swedish</option>
            <option value="th">ไทย</option>
            <option value="tr">Türkçe</option>
            <option value="uk">Ukranian</option>
            <option value="vi">Việt-ngữ</option>
          </select>
          <button id="start-translate" className="button is-secondary">
            Go
          </button>
        </div>
      </div>
      <h2>Professionally translated information</h2>
      <nav className="live-tiles four">
        <div>
          <p>
            <a href="!#">Arabic</a>
          </p>
          <p>
            <strong>
              <a href="!#">عربي</a>
            </strong>
          </p>
          <a href="!#">
            <Icon name="arrow" />
          </a>
        </div>
        <div>
          <p>
            <a href="!#">Simplified Chinese</a>
          </p>
          <p>
            <strong>
              <a href="!#">简体中文</a>
            </strong>
          </p>
          <a href="!#">
            <Icon name="arrow" />
          </a>
        </div>
        <div>
          <p>
            <strong>
              <a href="!#">Traditional Chinese</a>
            </strong>
          </p>
          <p>
            <strong>
              <a href="!#">简体中文</a>
            </strong>
          </p>
          <a href="!#">
            <Icon name="arrow" />
          </a>
        </div>
        <div>
          <p>
            <a href="!#">Croatian</a>
          </p>
          <p>
            <strong>
              <a href="!#">Hrvatski</a>
            </strong>
          </p>
          <a href="!#">
            <Icon name="arrow" />
          </a>
        </div>
        <div>
          <p>
            <a href="!#">Dari</a>
          </p>
          <p>
            <strong>
              <a href="!#">دری</a>
            </strong>
          </p>
          <a href="!#">
            <Icon name="arrow" />
          </a>
        </div>
        <div>
          <p>
            <a href="!#">Filipino</a>
          </p>
          <p>
            <strong>
              <a href="!#">Filipino</a>
            </strong>
          </p>
          <a href="!#">
            <Icon name="arrow" />
          </a>
        </div>
        <div>
          <p>
            <a href="!#">French</a>
          </p>
          <p>
            <strong>
              <a href="!#">Fran&ccedil;ais</a>
            </strong>
          </p>
          <a href="!#">
            <Icon name="arrow" />
          </a>
        </div>
        <div>
          <p>
            <a href="!#">German</a>
          </p>
          <p>
            <strong>
              <a href="!#">Deutsch</a>
            </strong>
          </p>
          <a href="!#">
            <Icon name="arrow" />
          </a>
        </div>
      </nav>
      <p className="s-mob-only">
        Or check out our{' '}
        <a href="!#">professionally translated versions of this website</a>.
      </p>
    </div>
  )
}
